export const AlignTopIcon = {
  default: {
    a: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
    },
    path: [
      {
        d: "M5 3.75L19 3.75",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      {
        d: "M7 6.25L7 20.25H11L11 6.25L7 6.25Z",
        fill: "currentColor",
      },
      {
        d: "M13 6.25L13 12.25H17L17 6.25L13 6.25Z",
        fill: "currentColor",
      },
    ],
  },
};
